<template>
<div class="pay-02">
  <div class="popup" :class="{ 'is-active': isFinalPay }">
        <div class="overlay"></div>
        <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
            <div class="card">
                <div class="card-body text-center pt-4 pb-4">
                    <div class="text-center p-2">
                        <h3 class="font-weight-light">ชำระค่างวดสำเร็จ</h3>
                    </div>
                    <!-- <div class="img-container text-center mb-3 mt-3"><img :src="$util.asset('goobank_assets/favicons/apple-icon-57x57.png')" /></div> -->
                    <div class="text-center p-2">
                        <p class="h6 font-weight-light">ท่านชำระเงินเป็นจำนวน</p>

                        <p v-if="this.$route.query.type == 'MORTGAGE'" class="h4 font-weight-bold">{{ this.paidValue | money}} บาท</p>
                        <p v-else class="h4 font-weight-bold">{{sumSelected() | money}} บาท</p>

                        <p class="h6 font-weight-light">ของสัญญาเงินกู้ #{{$route.query.contractNo}}</p>
                        <!-- <p class="h6 font-weight-light m-0">ยอดเงินกู้คงเหลือ 10,000 บาท</p> -->
                    </div>
                    <a class="btn btn-primary btn-lg btn-block mt-3 mb-3" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
                </div>
            </div>
        </div>
    </div>
    <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
    <template v-else>

        <template v-if="this.$route.query.type == 'MORTGAGE'">
            <div v-if="this.isLoadingMortgage == false && mortgageDummyReady" class="container pr-4 pl-4 pt-5">

                <!-- งวดค้างชำระก่อนหน้า - แสดงทุกกรณีที่มีงวดค้าง ไม่ว่าเงินใน wallet จะพอหรือไม่ -->
                <div v-if="overduePeriods.length > 0" class="new-design mb-2" style="border:2px solid #dc3545; border-radius:8px; padding:12px;">
                    <div class="text-center pb-2">
                        <h6 class="text-danger font-weight-bold m-0">⚠ ค้างชำระ {{ overduePeriods.length }} งวด</h6>
                        <small class="text-muted">ชำระค่างวด = จ่ายทีละงวด เริ่มจากงวดเก่าสุด</small>
                    </div>
                    <table class="table table-sm mb-0">
                        <thead>
                            <tr>
                                <th>งวดที่</th>
                                <th>ครบกำหนด</th>
                                <th class="text-right">ค้างกี่วัน</th>
                                <th class="text-right">ค่างวด</th>
                                <th class="text-right text-danger">เบี้ยปรับ</th>
                                <th class="text-right">รวม</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(op, idx) in overduePeriods" :key="op.period"
                                :style="idx === 0 ? 'background:#fff3cd; font-weight:bold;' : 'color:#999;'">
                                <td>{{ op.period }} <span v-if="idx === 0" class="badge badge-warning" style="font-size:10px;">ชำระต่อไป</span></td>
                                <td>{{ op.due_date_formatted }}</td>
                                <td class="text-right text-danger">{{ op.overdue_days }} วัน</td>
                                <td class="text-right">{{ op.pmt | money }}</td>
                                <td class="text-right text-danger">{{ op.penalty | money }}</td>
                                <td class="text-right">{{ op.total_with_penalty | money }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="mortgageDummyReady && this.dummyPayMortgageResult.data.code == 'W-MONEY_INSUFFICENT_B'">

                    <div class="new-design">
                        <div class="text-center p-3">
                            <h5 class="font-weight-normal m-2 p-3" style="font-size:30px; color:red">ขออภัย เงินใน Wallet ไม่พอ</h5>
                            <h5 class="font-weight-normal m-2">ยอดค้างชำระงวดที่ {{ this.dummyPayMortgageResult.data.data.period }}/{{ this.allPeriod }}</h5>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 0" class="font-weight-normal m-2">(ปกติ)</h6>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 1" class="font-weight-normal m-2">(เลยกำหนดชำระ)</h6>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 2" class="font-weight-normal m-2">(อยู่ในช่วงผ่อนผัน)</h6>
                            <h2 class="font-weight-bold m-2" :class="{'text-info': this.dummyPayMortgageResult.data.data.is_postpone == 0, 'text-danger': this.dummyPayMortgageResult.data.data.is_postpone == 1, 'text-success': this.dummyPayMortgageResult.data.data.is_postpone == 2}">{{ $currency(this.amountPMT) | money }}</h2>
                            <span class="badge badge-payment-date m-2"  :class="{'badge-info': this.dummyPayMortgageResult.data.data.is_postpone == 0, 'badge-danger': this.dummyPayMortgageResult.data.data.is_postpone == 1, 'badge-success': this.dummyPayMortgageResult.data.data.is_postpone == 2}">{{ this.periodText }}</span>
                        </div>

                        <table class="table table-payment">
                            <tr>
                                <td>วันครบกำหนด</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('due_date_formatted') }}</td>
                            </tr>
                            <tr>
                                <td>จำนวนวันที่ล่าช้าไป</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_exceed_days', 0) }} วัน</td>
                            </tr>
                            <tr>
                                <td>จำนวนที่จะครบกำหนด</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_will_due_days', 0) }} วัน</td>
                            </tr>
                            <tr>
                                <td>จำนวนวันของเดือน</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_month_days', 0) }} วัน</td>
                            </tr>
                        </table>

                        <div class="text-center p-3">
                            <h6 class="font-weight-normal m-0">สรุปยอดเรียกเก็บเงิน ณ {{ mortgageSummaryField('pay_date') }}</h6>
                        </div>

                        <table class="table table-payment mb-4">
                            <tr>
                                <td>เป็นเงินต้น </td>
                                <td>{{ $currency(mortgagePrincipalAmount()) | money}}</td>
                            </tr>
                            <tr>
                                <td>ดอกเบี้ย</td>
                                <td>{{ $currency(mortgageNormalInterest()) | money }}</td>
                            </tr>

                            <!-- ✅ เพิ่มบรรทัดนี้: ดอกเบี้ยปรับ (อยู่ใต้เงินต้น) -->
                            <tr>
                                <td class="pl-4 text-danger">เบี้ยปรับผิดนัดชำระ</td>
                                <td class="text-danger">
                                    {{ $currency(mortgagePenaltyInterest()) | money }}
                                </td>
                            </tr>
                            
                            <tr>
                                <td>เงินดาวน์</td>
                                <td>{{ (this.downAmount) | money }}</td>
                            </tr>
                            
                            <tr>
                                <td>จ่ายไปแล้วทั้งหมด</td>
                                <td class="text-success">{{ display.paidAmount | money }}</td>
                            </tr>
                            <tr>
                                <td>เหลือค้างจ่ายทั้งหมด</td>
                                <!-- <td class="text-danger">{{ (this.contractAmount - this.downAmount - display.paidAmount) | money }}</td> -->
                                <td class="text-danger kim">{{ display.dueAmount | money }}</td>
                            </tr>
                        </table>
                    </div>

                </div>
                <div v-else>

                    <div class="new-design">
                        <div class="text-center p-3">
                            <h5 class="font-weight-normal m-2">ยอดค้างชำระงวดที่ {{ this.dummyPayMortgageResult.data.data.period }}/{{ this.allPeriod }}</h5>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 0" class="font-weight-normal m-2">(ปกติ)</h6>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 1" class="font-weight-normal m-2">(เลยกำหนดชำระ)</h6>
                            <h6 v-if="this.dummyPayMortgageResult.data.data.is_postpone == 2" class="font-weight-normal m-2">(อยู่ในช่วงผ่อนผัน)</h6>
                            <h2 class="font-weight-bold m-2" :class="{'text-info': this.dummyPayMortgageResult.data.data.is_postpone == 0, 'text-danger': this.dummyPayMortgageResult.data.data.is_postpone == 1, 'text-success': this.dummyPayMortgageResult.data.data.is_postpone == 2}">{{ $currency(this.amountPMT) | money }}</h2>
                            <span class="badge badge-payment-date m-2"  :class="{'badge-info': this.dummyPayMortgageResult.data.data.is_postpone == 0, 'badge-danger': this.dummyPayMortgageResult.data.data.is_postpone == 1, 'badge-success': this.dummyPayMortgageResult.data.data.is_postpone == 2}">{{ this.periodText }}</span>
                        </div>

                        <table class="table table-payment">
                            <tr>
                                <td>วันครบกำหนด </td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('due_date_formatted') }}</td>
                            </tr>
                            <tr>
                                <td>จำนวนวันที่ล่าช้าไป</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_exceed_days', 0) }} วัน</td>
                            </tr>
                            <tr>
                                <td>จำนวนที่จะครบกำหนด</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_will_due_days', 0) }} วัน</td>
                            </tr>
                            <tr>
                                <td>จำนวนวันของเดือน</td>
                                <td :class="{'text-info': mortgageSummaryField('is_postpone') == 0, 'text-danger': mortgageSummaryField('is_postpone') == 1, 'text-success': mortgageSummaryField('is_postpone') == 2}">{{ mortgageSummaryField('mortgage_month_days', 0) }} วัน</td>
                            </tr>
                        </table>

                        <div class="text-center p-3">
                            <h6 class="font-weight-normal m-0">สรุปยอดเรียกเก็บเงิน ณ ปกติ {{ mortgageSummaryField('pay_date') }}</h6>
                        </div>

                        <table class="table table-payment mb-4">
                            <tr>
                                <td>เป็นเงินต้น </td>
                                <td>{{ $currency(mortgagePrincipalAmount()) | money}}</td>
                            </tr>
                            <tr>
                                <td>ดอกเบี้ย</td>
                                <td>{{ $currency(mortgageNormalInterest()) | money }}</td>
                            </tr>

                            <!-- ✅ เพิ่มบรรทัดนี้: ดอกเบี้ยปรับ (อยู่ใต้เงินต้น) -->
                            <tr>
                                <td class="pl-4 text-danger">เบี้ยปรับผิดนัดชำระ</td>
                                <td class="text-danger">
                                    {{ $currency(mortgagePenaltyInterest()) | money }}
                                </td>
                            </tr>
                            
                            <tr>
                                <td>เงินดาวน์</td>
                                <td>{{ (this.downAmount) | money }}</td>
                            </tr>
                            
                            <tr>
                                <td>จ่ายไปแล้วทั้งหมด</td>
                                <td class="text-success">{{ display.paidAmount | money }}</td>
                            </tr>
                            <tr>
                                <td>เหลือค้างจ่ายทั้งหมด</td>
                                <!-- <td class="text-danger">{{ (this.contractAmount - this.downAmount - display.paidAmount) | money }}</td> -->
                                <td class="text-danger kim">{{ display.dueAmount | money }}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="container">
                        <div class="row">
                            <ul class="w-100 nav nav-tabs nav-fill nav-payment-tab" id="myTab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link" :class="{'active' : this.currentTab == 'PAYMENT_NORMAL'}" @click.prevent="selectTab('PAYMENT_NORMAL')">ชำระค่างวด</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{'active' : this.currentTab == 'PAYMENT_SPECIFY'}" @click.prevent="selectTab('PAYMENT_SPECIFY')">ระบุจำนวน</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{'active' : this.currentTab == 'PAYMENT_ALL'}" @click.prevent="selectTab('PAYMENT_ALL')">ชำระทั้งหมด</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div style="background:#ddd">
                        <div class="row pt-4">
                            <div class="col">
                                <div class="form-group form-goobank">
                                    <!-- <input :readonly="this.currentTab == 'PAYMENT_NORMAL' || this.currentTab == 'PAYMENT_ALL'" class="form-control text-center form-control-cta input-decimal-mask-goobank" name="amount" type="number" v-model.number="amount" /> -->
                                    <input
                                        type="number"
                                        class="form-control"
                                        :readonly="this.currentTab == 'PAYMENT_NORMAL' || this.currentTab == 'PAYMENT_ALL'"
                                        v-model.number="amount"
                                        placeholder="กรอกยอดที่ต้องการชำระ"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>

        <template v-else>
            <ul class="list-group payment-page-style">
                <li class="list-group-item pt-4 pl-4 pb-4 pr-0" v-for="invoice in invoices" :key="invoice.id">
                    <div class="container">
                        <div class="row">
                            <div class="col custom-control custom-checkbox w-100">
                                <input class="custom-control-input" :id="'period-' + invoice.id" type="checkbox" :value="invoice.id" v-model="checkedInvoices" />
                                <label class="custom-control-label text-dark pt-1" :for="'period-' + invoice.id">
                                    <div class="container pr-0">

                                        <div v-if="invoice.isPostpone == 0" class="row w-100">
                                            <div class="col-8 pl-1">
                                                <p class="mb-1">งวดที่ {{invoice.periodNum}}</p>
                                                <p class="m-0 text-secondary"><small>ยอดผ่อน {{invoice.amount | money}} บาท</small></p>
                                                <p class="m-0 text-secondary"><small>ดอกเบี้ย {{invoice.interestAmount | money}} บาท</small></p>
                                                <p class="mt-1 mb-0 text-success"><small>กำหนดชำระ {{$dayjs(invoice.dueDate).format('D MMM YYYY')}}</small></p>
                                            </div>
                                            <div class="col-4 pr-0 text-right">
                                                <p class="m-0">{{ invoice.amount + invoice.interestAmount | money}}</p>
                                            </div>
                                        </div>
                                        <div v-if="invoice.isPostpone == 1" class="row w-100">
                                            <div class="col-8 pl-1">
                                                <p class="mb-1">งวดที่ {{invoice.periodNum}}</p>
                                                <p class="m-0 text-secondary"><small>ยอดผ่อน {{invoice.amount | money}} บาท</small></p>
                                                <p class="m-0 text-secondary"><small>ดอกเบี้ยปรับ {{invoice.interestDisputeAmount | money}} บาท</small></p>
                                                <p class="mt-1 mb-0 text-danger"><small>เลยกำหนดชำระ {{$dayjs(invoice.dueDate).format('D MMM YYYY')}}</small></p>
                                            </div>
                                            <div class="col-4 pr-0 text-right">
                                                <p class="m-0">{{ invoice.amount + invoice.interestDisputeAmount | money}}</p>
                                            </div>
                                        </div>
                                        <div v-if="invoice.isPostpone == 2" class="row w-100">
                                            <div class="col-8 pl-1">
                                                <p class="mb-1">งวดที่ {{invoice.periodNum}}</p>
                                                <p class="m-0 text-secondary"><small>ยอดผ่อน {{invoice.amount | money}} บาท</small></p>
                                                <p class="m-0 text-secondary"><small>อยู่ในช่วงผ่อนผัน</small></p>
                                                <p class="mt-1 mb-0 text-success"><small>(อยู่ในช่วงผ่อนผัน) แม้เลยกำหนดชำระ {{$dayjs(invoice.dueDate).format('D MMM YYYY')}}</small></p>
                                            </div>
                                            <div class="col-4 pr-0 text-right">
                                                <p class="m-0">{{ invoice.amount | money}}</p>
                                            </div>
                                        </div>

                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </template>

        <div class="stick-down-pusher stick-down-pusher-lg pt-4"></div>



        <div class="stick-down-fixed pt-3 pr-4 pl-4 pb-4 bg-white shadow xx">
            <error-cant-reach-server-small :errorData="errorData" v-if="isCantReachWhenSubmit" class="mt-4" ctaText="ลองส่งอีกครั่ง"></error-cant-reach-server-small>
            <div class="container pb-3 pr-0 pl-0">
                <div class="row">
                    <template v-if="this.$route.query.type == 'MORTGAGE'">
                        <div class="col d-flex align-items-left">
                            <p class="h6 m-0">จ่ายทั้งสิ้น</p>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col d-flex align-items-center" v-if="sumSelected() > 0">
                            <p class="h6 m-0">ยอดเงินที่ชำระ</p>
                        </div>
                    </template>
                    <div class="col text-right">
                        <p v-if="this.$route.query.type == 'MORTGAGE'" class="h3 m-0">{{ this.amount | money}}</p>
                        <p v-if="this.$route.query.type == 'MORTGAGE' && mortgagePenaltyAmount() > 0" class="m-0 text-secondary">
                        <small>
                            ยอดหักจริง = {{ this.amount | money }} + {{ mortgagePenaltyAmount() | money }} = {{ mortgageRealDebitAmount() | money }}
                        </small>
                        </p>
                        <p v-else class="h3 m-0">{{sumSelected() | money}}</p>
                    </div>
                </div>
                <div v-if="this.$route.query.type != 'MORTGAGE'" class="row">
                    <div class="col text-secondary font-weight-normal text-center">
                        <p class="m-0">
                            <small>ยอดค้างจ่าย <span class="text-danger">{{display.dueAmount | money}} บาท</span></small>
                            <small>ยอดจ่ายแล้ว <span class="text-success">{{display.paidAmount | money}} บาท</span></small>
                        </p>
                        <p class="m-0">
                            <small>ยอดเงินปัจจุบัน {{display.maxAmountOfMoney | money}}</small>
                        </p>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col text-secondary font-weight-normal text-right">
                        <p class="m-0">
                            <small>ยอดเงินปัจจุบัน {{display.maxAmountOfMoney | money}}</small>
                        </p>
                    </div>
                </div>
            </div>
            <div class="container p-0">
                <div class="row mr-0 ml-0">
                    <div class="col-5 pr-1 pl-0">
                        <button
                        class="btn btn-light btn-lg btn-block m-0"
                        @click="$router.go(-1)" >ย้อนกลับ</button>
                    </div>
                    <div class="col-7 pr-0 pl-1">
                        <button
                        class="btn btn-primary btn-lg btn-block m-0 v1.00"
                        :disabled="isDisabled()"
                        @click="pay()" >ชำระเงิน</button>
                    </div>
                </div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
export default {
  data: () => ({
    isCantReach: false,
    errorData: {},
    isCantReachWhenSubmit: false,
    isFinalPay: false,
    isProcessingNewCheckInvoices: false,
    isLoadingMortgage: false,
    isProcessingDummyPayment: false,
    invoices: [],
    checkedInvoices: [],
    display: {
      maxAmountOfMoney: '?',
      dueAmount: '?',
      paidAmount: '?'
    },
    amount: 0,
    amountPMT: 0,
    advanceDays: 0,
    paidValue: 0,
    dummyPayMortgageResult: undefined,
    mortgageSummaryData: null,
    overduePeriods: [],

    interestRate: 0,
    disputeInterestRate: 0,

    periodText: '',
    contractAmount: 0,
    currentTab: 'PAYMENT_NORMAL',
    allPeriod: 0
  }),
  watch: {
      checkedInvoices: {
          handler () {
              if (this.isProcessingNewCheckInvoices) return
              if (!this.isProcessingNewCheckInvoices) {
                this.isProcessingNewCheckInvoices = true
                const invoiceIndexes = this.checkedInvoices.map((invoiceId) => {
                    let invoiceIndexOfThisInvoiceId = -1
                    this.invoices.forEach((invoice, invoiceIndex) => {
                        if (invoice.id === invoiceId) invoiceIndexOfThisInvoiceId = invoiceIndex
                    })
                    return invoiceIndexOfThisInvoiceId
                    //   return this.invoices.filter((invoice, invoiceIndex) => invoice.id === invoiceId)[0]
                })
                const maxIndex = Math.max(...invoiceIndexes) // get max index in checked array
                const newCheckedInvoice = []
                if (isFinite(maxIndex)) {
                    new Array(maxIndex + 1).fill(0).forEach((a, index) => {
                        newCheckedInvoice.push(this.invoices[index].id)
                    })
                }
                this.$nextTick(() => {
                    this.checkedInvoices = newCheckedInvoice
                    this.$nextTick(() => {
                        this.isProcessingNewCheckInvoices = false
                    })
                })
              }
          },
          deep: true
      },
      amount: {
        async handler () {
          await this.reloadPayDummyContractMortgage();
        },
        deep: true
      },
      advanceDays: {
        async handler () {
          await this.reloadPayDummyContractMortgage();
        },
        deep: true
      },
  },
  async created () {
    const walletResult = await this.$api.wallet.get()
    this.display.maxAmountOfMoney = walletResult.data.current_money

    const result = await this.$api.pay.getInvoices(this.$route.params.id)
    const data = result.data
    if (!data.success) {
      this.isCantReach = true
      this.errorData = data
      return
    }
    this.invoices = data.invoices.filter((elm) => !elm.isPaid)
    this.calculateDisplayMoney(data.contractDetail)

    if(this.$route.query.type == 'MORTGAGE') {
        this.isLoadingMortgage = true;
        const result_contract_list = await this.$api.contract.list(this.$route.params.id);

        this.periodText = result_contract_list.data.contracts[0].periodText;
        this.contractAmount = result_contract_list.data.contracts[0].info.moneyPayload.amount;
        this.downAmount = result_contract_list.data.contracts[0].info.thingPayload.downPaymentAmount;
        this.allPeriod = result_contract_list.data.contracts[0].allPeriod;

        this.amount = result_contract_list.data.contracts[0].info.moneyPayload.perPeriod;
        this.amountPMT = result_contract_list.data.contracts[0].info.moneyPayload.perPeriod;

        this.interestRate = result_contract_list.data.contracts[0].info.moneyPayload.interest || 0;
        this.disputeInterestRate = result_contract_list.data.contracts[0].info.moneyPayload.dispute_interest || 0;

        this.isLoadingMortgage = false;

        await this.reloadPayDummyContractMortgage();
        this.selectTab('PAYMENT_NORMAL');
    }
  },
  computed: {
  mortgageDummyReady () {
    return (
      this.dummyPayMortgageResult &&
      this.dummyPayMortgageResult.data &&
      this.dummyPayMortgageResult.data.data
    )
  }
},
  methods: {
    selectTab(tab) {
      this.currentTab = tab;
      if(this.currentTab == 'PAYMENT_NORMAL') {
          this.amount = this.normalInstallmentAmount();
      } else if(this.currentTab == 'PAYMENT_SPECIFY') {

      } else if(this.currentTab == 'PAYMENT_ALL') {
          this.amount = this.fullSettlementAmount();
      }
    },
    async reloadPayDummyContractMortgage() {
        this.isProcessingDummyPayment = true;
        this.dummyPayMortgageResult = await this.$api.pay.payDummyContractMortgage(this.$route.params.id, this.amount, this.advanceDays);
        const d = this.getMortgageDummyData()
        if (d && !this.mortgageSummaryData) {
            this.mortgageSummaryData = { ...d }
        }
        if (this.dummyPayMortgageResult && this.dummyPayMortgageResult.data && Array.isArray(this.dummyPayMortgageResult.data.overdue_periods)) {
            this.overduePeriods = this.dummyPayMortgageResult.data.overdue_periods;
        }
        this.isProcessingDummyPayment = false;
    },
    isCalculating () {
        if (this.isProcessingDummyPayment) return true
        return false
    },
    calculateDisplayMoney (contractDetail) {
        this.display.dueAmount = contractDetail.remaining
        this.display.paidAmount = contractDetail.paid
    },
isDisabled() {

  if (this.$route.query.type === 'MORTGAGE') {

    if (!this.mortgageDummyReady) return true;

    var result = this.dummyPayMortgageResult;

    if (!result || !result.data || !result.data.data) return true;

    var data = result.data.data;
    var code = result.data.code;

    if (code === 'W-MONEY_INSUFFICENT_B') return true;

    var amount = Number(this.amount || 0);
    var wallet = Number(this.display.maxAmountOfMoney || 0);

    if (!(amount > 0)) return true;
    if (amount > wallet) return true;

    // PAYMENT_SPECIFY: ถ้างวดยังไม่จ่าย (sub_period=0) → ต้อง >= PMT
    // ถ้างวดจ่ายครบแล้ว (sub_period>=1) → extra principal จ่ายเท่าไหรก็ได้
    if (this.currentTab === 'PAYMENT_SPECIFY') {
      const dummySubPeriod = Number(this.mortgageSummaryField('sub_period', 0))
      if (dummySubPeriod === 0) {
        const minPayment = Number(this.normalInstallmentAmount() || 0)
        if (amount < minPayment) return true
      }
    }

    var isPostpone = Number(data.is_postpone || 0);

    // แทน ?? 0 แบบเก่า
    var willDueRaw = data.mortgage_will_due_days;
    var willDueDays = (willDueRaw === null || willDueRaw === undefined) ? 0 : Number(willDueRaw);

    // กติกาใหม่: จ่ายบางส่วนได้ทุกสถานะ (ตัดเงินต้นก่อน)
    // เหลือแค่เงื่อนไขเงิน > 0 และไม่เกิน wallet
    return false;
  }

  return this.sumSelected() <= 0 || this.sumSelected() > this.display.maxAmountOfMoney;
},


    sumSelected () {
      let sum = 0
      this.checkedInvoices.forEach((invoiceId) => {
        const selectedInvoice = this.invoices.filter((invoice) => invoice.id === invoiceId)[0]
        if(selectedInvoice.isPostpone === 0) {
            sum += selectedInvoice.amount + selectedInvoice.interestAmount;
        } else if(selectedInvoice.isPostpone === 1) {
            sum += selectedInvoice.amount + selectedInvoice.interestDisputeAmount;
        } else if(selectedInvoice.isPostpone === 2) {
            sum += selectedInvoice.amount;
        }
      })
      return sum
    },

    mortgageRealDebitAmount () {
  // ใช้ยอดหักจริงจาก dummy (paid_value) เพื่อให้ตรงกับ backend
  if (!this.dummyPayMortgageResult || !this.dummyPayMortgageResult.data || !this.dummyPayMortgageResult.data.data) {
    return Number(this.amount || 0)
  }
  const v = Number(this.dummyPayMortgageResult.data.data.paid_value)
  if (!isFinite(v) || v <= 0) return Number(this.amount || 0)
  return v
},
mortgagePenaltyAmount () {
  const real = Number(this.mortgageRealDebitAmount() || 0)
  const base = Number(this.amount || 0)
  const p = real - base
  return p > 0 ? p : 0
},


    async pay () {
      this.isCantReachWhenSubmit = false
      let result;
      if(this.$route.query.type == 'MORTGAGE') {
          result = await this.$api.pay.payContractMortgage(this.$route.params.id, this.amount, this.advanceDays)
      } else {
          result = await this.$api.pay.payInvoices(this.$route.params.id, this.checkedInvoices);
      }

      const data = result.data

      if(this.$route.query.type == 'MORTGAGE') {
        this.paidValue = data.pay_value;
      }

      if (!data.success) {
        this.isCantReachWhenSubmit = true
        return
      }
      this.isFinalPay = true
    },

        getMortgageDummyData () {
        if (
            !this.dummyPayMortgageResult ||
            !this.dummyPayMortgageResult.data ||
            !this.dummyPayMortgageResult.data.data
        ) {
            return null
        }

        return this.dummyPayMortgageResult.data.data
        },

getMortgageSummaryData () {
  if (this.mortgageSummaryData) return this.mortgageSummaryData
  return this.getMortgageDummyData()
},

mortgageSummaryField (key, fallback = '') {
  const d = this.getMortgageSummaryData()
  if (!d) return fallback
  const val = d[key]
  return (val === undefined || val === null) ? fallback : val
},

normalInstallmentAmount () {
  if (this.overduePeriods.length > 0) {
    // Pay oldest overdue period first (one month at a time)
    return Number(this.overduePeriods[0].total_with_penalty || 0)
  }
  const installment = Number(this.amountPMT || 0)
  const penalty = Number(this.mortgagePenaltyInterest() || 0)
  return Math.round((installment + penalty + Number.EPSILON) * 100) / 100
},

fullSettlementAmount () {
  const remain = Number(this.display.dueAmount || 0)
  const interest = Number(this.mortgageNormalInterest() || 0)
  const penalty = Number(this.mortgagePenaltyInterest() || 0)
  return Math.round((remain + interest + penalty + Number.EPSILON) * 100) / 100
},

mortgagePrincipalAmount () {
  const d = this.getMortgageSummaryData()
  if (!d) return 0
  return Number(d.is_principle || 0)
},

mortgageBaseRemainAmount () {
  // base ยอดคงเหลือก่อนจ่ายงวดนี้
  // remain_before = remaining_priciple(remain_after) + is_principle(principal_pay)
  const d = this.getMortgageSummaryData()
  if (!d) return 0
  const remainAfter = Number(d.remaining_priciple || 0)
  const principalPay = Number(d.is_principle || 0)
  return remainAfter + principalPay
},

mortgageNormalInterest () {
  const d = this.getMortgageSummaryData()
  if (!d) return 0

  // ช่วงผ่อนผัน -> ถือว่าดอกเบี้ยเป็น 0 (ตามที่ UI แสดงว่าอยู่ในช่วงผ่อนผัน)
  if (Number(d.is_in_exempt_period)) return 0

  const base = this.mortgageBaseRemainAmount()
  const monthDays = Number(d.mortgage_month_days || 0)
  const rate = Number(this.interestRate || 0)

  const interest = (base * rate * monthDays) / 365.0
  return interest > 0 ? interest : 0
},

mortgagePenaltyInterest () {
  // When overdue periods exist, use pre-computed penalty from backend (correct base = PMT - interest)
  if (this.overduePeriods.length > 0) {
    return Number(this.overduePeriods[0].penalty || 0)
  }

  const d = this.getMortgageSummaryData()
  if (!d) return 0

  // ช่วงผ่อนผัน -> 0
  if (Number(d.is_in_exempt_period)) return 0

  const principal = Number(d.is_principle || 0)
  const overdueDays = Number(d.mortgage_exceed_days || 0)
  let disputeRate = Number(this.disputeInterestRate || 0)

  // รองรับทั้ง 15 และ 0.15
  if (disputeRate > 1) disputeRate = disputeRate / 100

  if (!(principal > 0) || !(overdueDays > 0) || !(disputeRate > 0)) return 0

  // สูตรใหม่: (เงินต้นค่างวด x อัตราเบี้ยปรับ x จำนวนวันที่คงค้าง) / 365
  const penalty = (principal * disputeRate * overdueDays) / 365
  return Math.round((penalty + Number.EPSILON) * 100) / 100
},

  }
}
</script>

<style lang="scss">

</style>
